import SupportedNetworks from "./SupportedNetworks";

export default SupportedNetworks;
